<template>
  <a-modal
      :title="title"
      :visible="visible"
      @ok="ok"
      @cancel="cancel"
      okText='确定'
      cancelText='取消'
      destroyOnClose 
      :maskClosable="false"
      width="700px"
    >
      <template slot="footer">
        <a-button @click="cancel">取消</a-button>
        <a-button type="primary" @click="ok" :loading="submitLoading">确定</a-button>
      </template>
      <a-form :form="form" :label-col="{ span: 5 }" class="nomargin" :wrapper-col="{ span: 12 }">
        <a-form-item label="代码" v-if="type === 'edit'">
          <a-input
            disabled
            v-decorator="['customerCode']"
          />
        </a-form-item>
        <!-- ,{validator: checkName} -->
        <a-form-item label="名称">
          <a-input
            placeholder="请输入名称"
            v-decorator="['customerName', { rules: [{ required: true, message: '请输入名称' },{validator: checkName, trigger: 'change'}] }]"
          />
        </a-form-item>
        <a-form-item label="描述">
          <a-textarea
            v-decorator="['customerDescribe']"
            placeholder="请输入描述信息"
            :auto-size="{ minRows: 2, maxRows: 4 }"
            :maxLength="150"
          />
        </a-form-item>
      </a-form>
  </a-modal>
</template>

<script>
import api from '../api';
export default {
  props: ['visible','type','rowData'],
  data() {
    return {
      form: this.$form.createForm(this),
      detailData: {},
      submitLoading: false,
      factoryId: window.localStorage.getItem('factoryId'),
    }
  },
  computed: {
    title() {
      return this.type === 'edit' ? '编辑' : '新增'
    },
  },
  watch: {
    visible(val){
      if(val){
        let data = {name: '',describe: '',code: ''}
        if(this.type === 'edit') {
          this.detailData = Object.assign({},this.rowData)
          let {customerName,customerCode,customerDescribe} = this.rowData
          data = {customerName,customerCode,customerDescribe}
        }
        setTimeout(() => {
          this.form.setFieldsValue(data)
        }, 0);
      }
    }
  },
  methods: {
    checkName(rule, value, callback) {
      if(value){
        let str = ''
        let reg = /[*[\]：？<>/、\\.]/im; 
        let flag = reg.test(value)
        if(flag) {
          str = '配方名称不能包含*[]：？<>/、\\.等特殊字符'
        }
        if(value && value.length > 31){
          str = '长度：31个字符以内'
        }
        if(str) {
          callback(str);
        }else{
          callback()
        }
      }else{
        callback()
      }
      
    },
    addFactoryListConfirm(customId){
      this.$confirm({
        title: '新建客户',
        content: <p><span style={{color: 'red'}}>客户创建后，将默认导入工厂原料数据，</span><span style={{color: 'gray'}}>你还要继续吗？</span></p>,
        cancelText:'取消',
        okText:'确定',
        onOk: async () => {
          let data = {customId}
          console.log(data,'data')
        },
      })
    },
    async ok(){
      this.form.validateFields(async (err,values) => {
        if(!err){
          let data = {}
          let feild = 'addCustomerRow'
          this.submitLoading = true
          if(this.type === 'edit'){
            feild = 'editCustomerRow'
            data = {...this.rowData,...values}
          }else{
            data = {factoryId: this.factoryId,...values}
          }
          let res = await api[feild](data)
          this.submitLoading = false
          let {success,msg,code} = res || {}
          if(code != 400) this.$emit('close','addVisible',true)
          this.$message[success ? 'success' : 'warning'](msg)
        }
      })
    },
    cancel(){
      this.$emit('close','addVisible')
    },
  }
}
</script>